import styled, { css } from 'styled-components';
import { Typography, Button, Link, LanguageSelect } from '../../design-system';
// import { scrollToAnimation } from '../../utils';
import LOGO_PRIMARY_SVG from '../../images/LogoPrimary.svg';
import LOGO_WHITE_SVG from '../../images/Logo.svg';
import { i18n } from '../../i18n';

// NAVIGATION

const NavigationBase = styled.nav`
  position: sticky;
  top: 0;

  height: 8.8rem;
  background-color: var(--white);
  z-index: 1000;
`;

const NavigationWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 1fr;
  grid-column-gap: var(--spacing-6);
  align-items: center;

  max-width: 144rem;
  height: 100%;
  margin: auto;
  padding: 0 var(--spacing-20);
`;

const LogoBase = styled.div`
  display: grid;
  grid-template-columns: repeat(2, max-content);
  grid-column-gap: var(--spacing-2);
  align-items: center;
  height: 3.4rem;
`;

const LogoImg = styled.img<LogoProps>`
  height: 3.4rem;
  object-fit: contain;
  object-position: center;

  ${(props) =>
    props.variant === 'white' &&
    css`
      width: 4rem;
    `}
`;

interface LogoProps {
  variant?: 'primary' | 'white';
}

export const Logo = ({ variant = 'primary', ...props }: LogoProps) => {
  return (
    <LogoBase {...props}>
      <LogoImg src={variant === 'primary' ? LOGO_PRIMARY_SVG : LOGO_WHITE_SVG} variant={variant} />
      <Typography
        variant={'h6'}
        weight={'bold'}
        color={variant === 'primary' ? '--primary-100' : '--white'}
      >
        TEZPORT
      </Typography>
    </LogoBase>
  );
};

interface CustomLinkProps {
  to: string;
  text: string;
  onClick?: (e: any) => void;
}

export const CustomLink: React.FC<CustomLinkProps> = ({ to, text, ...props }: CustomLinkProps) => {
  return (
    <Link to={to} maxwidth withunderline {...props}>
      <Typography variant="textM">{text}</Typography>
    </Link>
  );
};

const LanguageText = styled(Typography)`
  margin-left: -2.4rem;
`;

export const Navigation = () => {
  return (
    <NavigationBase>
      <NavigationWrapper>
        <Logo />
        <LanguageSelect isButtonVariant />
        {/* <CustomLink
          to={'#hero'}
          text={LANDING.NAV.HERO}
          onClick={(e) => scrollToAnimation(e, 'hero')}
        />
        <CustomLink
          to={'#key-features'}
          text={LANDING.NAV.KEY_FEATURES}
          onClick={(e) => scrollToAnimation(e, 'key-features')}
        />
        <CustomLink
          to={'#why-choose'}
          text={LANDING.NAV.WHY_CHOOSE}
          onClick={(e) => scrollToAnimation(e, 'why-choose')}
        />
        <CustomLink
          to={'#implementing'}
          text={LANDING.NAV.IMPLEMENTING}
          onClick={(e) => scrollToAnimation(e, 'implementing')}
        />
        <CustomLink
          to={'#reviews'}
          text={LANDING.NAV.REVIEWS}
          onClick={(e) => scrollToAnimation(e, 'reviews')}
        />
        <CustomLink
          to={'#contact-us'}
          text={LANDING.NAV.CONTACT_US}
          onClick={(e) => scrollToAnimation(e, 'contact-us')}
        /> */}
        <Button size={'large'} onClick={() => (window.location.href = '/signin')}>
          {i18n.t('pages.signin.title')}
        </Button>
      </NavigationWrapper>
    </NavigationBase>
  );
};

const MobileNavigationBase = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  grid-column-gap: var(--spacing-4);
  align-items: center;

  width: 100%;
  height: 6.8rem;

  background-color: var(--gray-90);
  border-bottom: 0.1rem solid var(--gray-50);
  padding: 0 var(--spacing-6);

  & > ${LanguageText} {
    margin-left: 0;
    margin-right: var(--spacing-3);
  }
`;

export const MobileNavigation = () => {
  return (
    <MobileNavigationBase>
      <Logo variant={'white'} />
      <LanguageSelect withText color="white" />
      <Button to={'/signin'} size={'medium'} data-color={'white'}>
        {i18n.t('button.signIn')}
      </Button>
    </MobileNavigationBase>
  );
};
